import React from 'react';
import Icon from './Icon';
import '../styles/StaffNavItem.css';

const StaffNavItem = ({ icon, label, isActive, onClick, isSubcategory = false }) => {
  return (
    <button
      className={`staff-nav-item ${isActive ? 'active' : ''} ${isSubcategory ? 'subcategory' : ''}`}
      onClick={onClick}
    >
      <span className="nav-icon">
        <Icon name={icon} size={16} />
      </span>
      <span className="nav-label">{label}</span>
    </button>
  );
};

export default StaffNavItem;